import {RheemEventCandidates} from "./RheemEventCandidates";
import {RheemIndicators} from "./RheemIndicators";
import { RheemNotes } from "../../components/RheemNotes";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
    container: {
        maxWidth: '100%',
        width: '100%',
        overflow: 'auto',
        padding: '0 16px',
    },
    section: {
        marginBottom: '40px',
    }
});

export const RheemDashboard = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.section}>
                <h2>Event Candidates</h2>
                <RheemEventCandidates />
            </div>

            <div className={classes.section}>
                <h2>Indicators</h2>
                <RheemIndicators />
            </div>

            <div className={classes.section}>
                <h2>Notes</h2>
                <RheemNotes />
            </div>
        </div>
    );
};
